import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Live from "../views/Live.vue";
import Terms from "../views/Terms.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/live",
    name: "Live",
    component: Live
  },
  {
    path: "/termimos-y-condiciones",
    name: "Terms",
    component: Terms
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to) {
    if (to.hash) {
      return {
        selector: to.hash
      };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

export default router;
